import { __spreadArray } from "tslib";
import { get } from 'lodash';
import { extractButton } from '../../utils/elements';
export var getButton = function (_a) {
    var region = _a.region, css = _a.css, _b = _a.isRtl, isRtl = _b === void 0 ? false : _b, _c = _a.experiments, experiments = _c === void 0 ? {} : _c, mixData = _a.mixData;
    var buttonStyles = get(region, 'data.styles.main', {});
    var defaultStyles = css['so-global-b1-mix'];
    var maxWidth = get(defaultStyles, 'maxWidth') || '300px';
    var minWidth = get(defaultStyles, 'minWidth') || '140px';
    var minCalculatedColumnWidth = Math.min.apply(null, __spreadArray([], mixData.data.layout.rows[0].columns, true).map(function (col) { return col.width; }));
    var button = extractButton({
        customStyles: buttonStyles,
        defaultStyles: defaultStyles,
        experiments: experiments,
        isRtl: isRtl,
        region: region,
        minCalculatedColumnWidth: minCalculatedColumnWidth,
    });
    return {
        button: button,
        regionId: region.regionId,
        type: 'button',
        minWidth: minWidth,
        maxWidth: maxWidth,
    };
};
//# sourceMappingURL=get-button.js.map